import React from "react";
import { H2, H4, Icon } from "@blueprintjs/core";
import styled from "styled-components";
import { Tooltip2 } from "@blueprintjs/popover2";

import { Box, CustomCard } from "..";
import HeaderStyle from "./header-style";

type Props = {
  /**
   * The children are used for the sub section of the header. If you want to
   * render a large component that needs a lot of real estate on the Y-axis
   * then do not use this prop.
   */
  children?: React.ReactNode;
  /**
   * The actual header title. Renders as a H2 tag.
   */
  title: string;
  /**
   * Sometimes a header needs some general, page-level actions. Put them here
   */
  actions?: React.ReactNode;
  /**
   * When we are in a nested situation in regards to the routes, it's always a
   * good idea to communicate to the user where they are
   */
  breadcrumbs?: React.ReactNode;
  /** Used for sub sections of a page */
  small?: boolean;
  isFastlane?: boolean;
  authorizedAgency?: React.ReactNode;
};

const PageSection = (props: Props) => {
  const {
    children,
    title,
    actions,
    breadcrumbs,
    small,
    isFastlane,
    authorizedAgency,
  } = props;
  const TitleComponent = small ? SmallTitle : BigTitle;

  return (
    <Wrapper>
      <Header>
        <Box flexDir="row">
          {breadcrumbs}
          {isFastlane ? (
            <Tooltip2 content={"Fastlane Task"}>
              <Icon
                icon="rocket-slant"
                size={18}
                style={{ marginLeft: "8px" }}
              />
            </Tooltip2>
          ) : null}
        </Box>
        <Box flex="row" justify="between" items="baseline">
          <Box flexDir="row" justify="between" items="baseline">
            <TitleComponent>{title}</TitleComponent> {authorizedAgency}
          </Box>
          {actions}
        </Box>
      </Header>
      {children}
    </Wrapper>
  );
};

const Wrapper = styled(CustomCard)`
  /** Making sure that the box-shadow of the Card becomes visible at the top */
  margin-top: 1px;
  box-shadow: unset !important;
`;

const Header = styled(HeaderStyle)`
  /** 
   * We want to keep the same margins and paddings as the Card component but we
   * also want to neggate the inner padding for our darker header 
  */
  //   margin: -20px -20px 20px -20px;
  // display: flex;
  // justify-content: space-between;
  padding: 10px 0px 17px 0px;
  // align-items: center;
  background-color: transparent;
`;

const BigTitle = styled(H2)`
  margin-bottom: 0;
`;

const SmallTitle = styled(H4)`
  margin-bottom: 0;
`;

export default PageSection;
